import React from 'react';
import classnames from 'classnames';

import './style.scss';

export interface IAccordionProps {
  isExpanded: boolean;
  isDisabled: boolean;
  title: React.ReactNode | string;
  children?: React.ReactNode;
  hideBorder?: boolean;
  onClick: () => void;
  contentId?: string;
}

export const Accordion = ({ title, children, isExpanded, isDisabled, onClick, hideBorder, contentId }: IAccordionProps) => {
  const generatedContentId = contentId || `accordion-content-${Math.random().toString(36).substr(2, 9)}`;
  
  return (
    <div className={classnames('accordion')}>
      <button
        type="button"
        className={classnames('accordion__header', {
          active: !isDisabled,
          disabled: isDisabled,
        })}
        onClick={(e) => {
          e.preventDefault();
          if (isDisabled) {
            return;
          }
          onClick();
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (!isDisabled) {
              onClick();
            }
          }
        }}
        aria-expanded={isExpanded}
        aria-controls={generatedContentId}
        aria-disabled={isDisabled}
        disabled={isDisabled}
      >
        {title}
      </button>
      <div
        id={generatedContentId}
        className={classnames('accordion__content', {
          expanded: isExpanded,
          collapsed: !isExpanded,
          borderless: hideBorder,
        })}
        role="region"
      >
        {children}
      </div>
    </div>
  );
};

export default Accordion;
